import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from '@mui/material/styles';
import { ProtectedRoute } from './components/ProtectedRoute';
import Login from './pages/Login';
import MenuDesignComponent from './pages/orders/MenuDesignComponent';
import Reservations from './pages/reservations';
import AdminReservations from './pages/admin/Reservations';
import AdminTables from './pages/admin/Tables';
import AdminLayout from './components/AdminLayout';
import Dashboard from './pages/admin/Dashboard';
import AdminSpecialRequests from './pages/admin/AdminSpecialRequests';
import GoogleReservationRedirect from './components/GoogleReservationRedirect';
import MenuAdminComponent from './pages/admin/menu/MenuAdminComponent';
import OrdersAdminComponent from './pages/admin/orders/OrdersAdminComponent';
import MenuComponent from './pages/orders/MenuComponent';
import RestaurantCheckout from './pages/orders/RestaurantCheckout';
import restaurantTheme from './theme/restaurantTheme';
import PromoRedirect from './components/PromoRedirect';
import MigrationTool from './components/MigrationTool';
import { CssBaseline } from '@mui/material';
import '@fontsource/playfair-display/400.css';
import '@fontsource/playfair-display/500.css';
import '@fontsource/playfair-display/600.css';
import '@fontsource/playfair-display/700.css';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ThemeProvider theme={restaurantTheme}>
          <CssBaseline />
          <Routes>
            {/* Rutas públicas */}
            <Route path="/" element={<Reservations />} />
            <Route path="/promo" element={<PromoRedirect />} />
            
            {/* Rutas de pedidos - separadas como solicitado */}
            <Route path="/carta" element={<MenuDesignComponent viewOnly={true} />} />
            <Route path="/pedido-mesa" element={<MenuComponent orderType="local" />} />
            <Route path="/pedido-recoger" element={<MenuComponent orderType="takeaway" />} />
            <Route path="/pedido-domicilio" element={<MenuComponent orderType="delivery" />} />
            <Route path="/pedido-checkout" element={<RestaurantCheckout />} />
            
            <Route path="/reservas-google" element={<GoogleReservationRedirect />} />
            <Route path="/login" element={<Login />} />

            {/* Rutas de administración */}
            <Route
              path="/admin"
              element={
                <ProtectedRoute requireAdmin>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="reservas" element={<AdminReservations />} />
              <Route path="solicitudes-especiales" element={<AdminSpecialRequests />} />
              <Route path="mesas" element={<AdminTables />} />
              <Route path="menu" element={<MenuAdminComponent />} />
              <Route path="pedidos" element={<OrdersAdminComponent />} />
              <Route path="/admin/migration" element={<MigrationTool />} />
            </Route>

            {/* Ruta por defecto - redirige a la página principal */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </ThemeProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;